import { api } from "@/api"
import { queryClient } from "@/queryClient"

export type UpdateMerchantGroupUserRequest = {
  email: string
  firstName: string
  lastName: string
}

export const updateMerchantGroupUser = async (
  userId: string,
  params: UpdateMerchantGroupUserRequest
) => {
  await api.put(`/merchant-group/users/${userId}/`, {
    body: params,
    isMerchantGroup: true,
  })
  queryClient.invalidateQueries([
    BASE_MERCHANT_GROUP_USERS_QUERY_KEY,
  ])
}
